export enum MailingListRoutingEnum {
  UnsubscribeMail = 'unsubscribe-mail',
}
